export default {
  title: 'Uw website is klaar',
  body_one: 'Reserveringen staan nog uit voor {{count}} restaurant:',
  body_other: 'Reserveringen staan nog uit voor {{count}} restaurants:',
  reasons: {
    license_required: 'Vereist een Partnerplan',
    notification_email_required:
      'Heeft een e-mailadres nodig voor boekingsmeldingen. Voeg het toe wanneer u reserveringen inschakelt.',
    switched_off: 'Uitgeschakeld in de reserveringsinstellingen',
    activation_failed: 'Kon niet worden ingeschakeld. Probeer het opnieuw in de reserveringsinstellingen.',
  },
  buttons: {
    open_settings: 'Reserveringsinstellingen openen',
    continue: 'Doorgaan naar de websitebouwer',
  },
};
